import Nullstack from 'nullstack';
export default function IconBlockquote({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-blockquote",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 15h15"
  }), "   ", Nullstack.element("path", {
    d: "M21 19h-15"
  }), "   ", Nullstack.element("path", {
    d: "M15 11h6"
  }), "   ", Nullstack.element("path", {
    d: "M21 7h-6"
  }), "   ", Nullstack.element("path", {
    d: "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
  }), " ");
}